import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row, Form, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

function Variables() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userx = useSelector(state => state.user);
    const [user, setUser] = useState({});

    const [sLoading, setSLoading] = useState(false);
    const [minPlayers, setMinPlayers] = useState("");
    const [minAmount, setMinAmount] = useState("");
    const [loading, setLoading] = useState(false);

    const LoadDefaultVariables = async () => {
        setLoading(true);
        
        const response = await axios.get(window.__CFG.API + "manager/LoadVariables", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        setLoading(false);

        if (response.data.Error == null) {
            setMinPlayers(response.data.Result.Players);
            setMinAmount(response.data.Result.Amount);
        }
    }

    useEffect(() => {
        LoadDefaultVariables();
    }, [])

    const SaveDefaultVariables = async () => {
        setSLoading(true);
        const response = await axios.post(window.__CFG.API + "manager/SaveVariables", {
            amount : minAmount,
            players : minPlayers
        }, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        setSLoading(false);

        if(response.data.Error == null) {
            toast.success("Updated Sucessufully", {
                duration: 4000
            }); 
        } else {
            toast.error(response.data.Error, {
                duration: 4000
            });
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h4 className="text-start fw-bold mt-5">Affiliate Variables</h4>
                    <div className='mt-3' style={{ lineHeight: "1" }} >
                        {
                            loading ? (
                                <>
                                    <Spinner size="sm" />
                                </>
                            ) : (
                                <>
                                    <Row className="justify-content-between mt-4 me-auto w-75">
                                        <>
                                            <Col lg={4} md={4} sm={5}>
                                                <div style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                                                    <div className='form-aff-list-in'>
                                                        <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                                                            <label style={{ fontSize: 12 }}>Minimum players for invoice generation</label>
                                                        </div>
                                                        <div className="dashboard-selec">
                                                            <Form.Control placeholder='Minimum players' style={{ fontSize: 14, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 4 }} type="text" value={minPlayers} onChange={(e) => { setMinPlayers(e.target.value) }} />
                                                        </div>
                                                    </div>

                                                    <div className='form-aff-list-in'>
                                                        <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                                                            <label style={{ fontSize: 12 }}>Minimum amount for invoice generation</label>
                                                        </div>
                                                        <div className="dashboard-selec">
                                                            <Form.Control placeholder='Minimum amount' style={{ fontSize: 14, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 4 }} type="text" value={minAmount} onChange={(e) => { setMinAmount(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div style={{ marginTop: "10px" }} className='full-button-width'>
                                                    <Button onClick={SaveDefaultVariables} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                                                        {
                                                            sLoading ? (
                                                                <><Spinner size="sm"></Spinner></>
                                                            ) : (
                                                                <>Save Settings</>
                                                            )
                                                        }
                                                    </Button>
                                                </div>
                                            </Col>
                                        </>
                                    </Row>
                                </>
                            )
                        }
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Variables;